export default __webpack_public_path__ + "static/media/deskGrey.181392e5.gif";